/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SitesRouteImport } from './routes/sites'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as FormDesignerRouteImport } from './routes/form-designer'
import { Route as EventsRouteImport } from './routes/events'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FormsIndexRouteImport } from './routes/forms.index'
import { Route as SitesSiteKeyRouteImport } from './routes/sites.$siteKey'
import { Route as FormsNewRouteImport } from './routes/forms.new'
import { Route as FormsFormKeyRouteImport } from './routes/forms.$formKey'

const SitesRoute = SitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const FormDesignerRoute = FormDesignerRouteImport.update({
  id: '/form-designer',
  path: '/form-designer',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsIndexRoute = FormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesSiteKeyRoute = SitesSiteKeyRouteImport.update({
  id: '/$siteKey',
  path: '/$siteKey',
  getParentRoute: () => SitesRoute,
} as any)
const FormsNewRoute = FormsNewRouteImport.update({
  id: '/forms/new',
  path: '/forms/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsFormKeyRoute = FormsFormKeyRouteImport.update({
  id: '/forms/$formKey',
  path: '/forms/$formKey',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/events': typeof EventsRoute
  '/form-designer': typeof FormDesignerRoute
  '/integrations': typeof IntegrationsRoute
  '/sites': typeof SitesRouteWithChildren
  '/forms/$formKey': typeof FormsFormKeyRoute
  '/forms/new': typeof FormsNewRoute
  '/sites/$siteKey': typeof SitesSiteKeyRoute
  '/forms/': typeof FormsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/events': typeof EventsRoute
  '/form-designer': typeof FormDesignerRoute
  '/integrations': typeof IntegrationsRoute
  '/sites': typeof SitesRouteWithChildren
  '/forms/$formKey': typeof FormsFormKeyRoute
  '/forms/new': typeof FormsNewRoute
  '/sites/$siteKey': typeof SitesSiteKeyRoute
  '/forms': typeof FormsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/events': typeof EventsRoute
  '/form-designer': typeof FormDesignerRoute
  '/integrations': typeof IntegrationsRoute
  '/sites': typeof SitesRouteWithChildren
  '/forms/$formKey': typeof FormsFormKeyRoute
  '/forms/new': typeof FormsNewRoute
  '/sites/$siteKey': typeof SitesSiteKeyRoute
  '/forms/': typeof FormsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/events'
    | '/form-designer'
    | '/integrations'
    | '/sites'
    | '/forms/$formKey'
    | '/forms/new'
    | '/sites/$siteKey'
    | '/forms/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/events'
    | '/form-designer'
    | '/integrations'
    | '/sites'
    | '/forms/$formKey'
    | '/forms/new'
    | '/sites/$siteKey'
    | '/forms'
  id:
    | '__root__'
    | '/'
    | '/events'
    | '/form-designer'
    | '/integrations'
    | '/sites'
    | '/forms/$formKey'
    | '/forms/new'
    | '/sites/$siteKey'
    | '/forms/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EventsRoute: typeof EventsRoute
  FormDesignerRoute: typeof FormDesignerRoute
  IntegrationsRoute: typeof IntegrationsRoute
  SitesRoute: typeof SitesRouteWithChildren
  FormsFormKeyRoute: typeof FormsFormKeyRoute
  FormsNewRoute: typeof FormsNewRoute
  FormsIndexRoute: typeof FormsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sites': {
      id: '/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof SitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form-designer': {
      id: '/form-designer'
      path: '/form-designer'
      fullPath: '/form-designer'
      preLoaderRoute: typeof FormDesignerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/': {
      id: '/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof FormsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites/$siteKey': {
      id: '/sites/$siteKey'
      path: '/$siteKey'
      fullPath: '/sites/$siteKey'
      preLoaderRoute: typeof SitesSiteKeyRouteImport
      parentRoute: typeof SitesRoute
    }
    '/forms/new': {
      id: '/forms/new'
      path: '/forms/new'
      fullPath: '/forms/new'
      preLoaderRoute: typeof FormsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/$formKey': {
      id: '/forms/$formKey'
      path: '/forms/$formKey'
      fullPath: '/forms/$formKey'
      preLoaderRoute: typeof FormsFormKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SitesRouteChildren {
  SitesSiteKeyRoute: typeof SitesSiteKeyRoute
}

const SitesRouteChildren: SitesRouteChildren = {
  SitesSiteKeyRoute: SitesSiteKeyRoute,
}

const SitesRouteWithChildren = SitesRoute._addFileChildren(SitesRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EventsRoute: EventsRoute,
  FormDesignerRoute: FormDesignerRoute,
  IntegrationsRoute: IntegrationsRoute,
  SitesRoute: SitesRouteWithChildren,
  FormsFormKeyRoute: FormsFormKeyRoute,
  FormsNewRoute: FormsNewRoute,
  FormsIndexRoute: FormsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
